import { searchbar } from './searchbar';
import { removeElement } from './helpers';
import { take } from 'rxjs/operators';

/*
    <div class="guests-cell-field">
        <label for="id_guests_child_1">Child 1</label>
        <input type="number" name="[guets_child_1]" id="id_guests_child_1" min="0" max="17" placeholder="Age">
    </div>
*/

class DropdownGuests {
  constructor(elements, guestsLimit, callback, searchModel) {
    this.elements = elements;
    this.searchModel = searchModel;
    this.guestsLimit = typeof guestsLimit === 'number' ? guestsLimit : false;
    this.callback = this.isFunction(callback) ? callback : false;

    this.translations = {};
    this.childItems = {};
    this.isOpened = false;
    this.validChildren = true;
    this.init();
  }

  isFunction(functionToCheck) {
    let getType = {};
    return (
      functionToCheck &&
      getType.toString.call(functionToCheck) === '[object Function]'
    );
  }

  init() {
    this.translations = {
      label: this.elements.template.getAttribute('data-label'),
      placeholder: this.elements.template.getAttribute('data-placeholder'),
    };
    this.getPreloadedValues();
    this.checkChildFields();
    this.bindEvents();
    this.searchModel.searchData$.pipe(take(1)).subscribe((eventObj) => {
      if ('adults' in eventObj) {
        this.setNumOfAdults(eventObj['adults']);
        let numOfChildren = 0;
        if ('children' in eventObj) {
          numOfChildren = eventObj['children'].length;
        }
        this.setTotalNumOfPersons(eventObj['adults'] + numOfChildren);
      }
    });
  }

  setNumOfAdults(numberOfAdults) {
    this.elements.adults_selector.querySelectorAll('option').forEach(element => {
      if (parseInt(element.value, 10) !== numberOfAdults) {
        element.selected = false;
      } else {
        element.selected = true;
      }
    });
  }

  setTotalNumOfPersons(totalNumberOfPersons) {
    this.elements.preview_value.innerHTML = totalNumberOfPersons;
  }

  bindEvents() {
    [...this.elements.select].map(item => {
      item.addEventListener('change', () => {
        this.previewValueUpdate();
      });
    });

    this.elements.select_children.addEventListener('change', () => {
      this.addRemoveChildItems(this.elements.select_children.value);
      this.checkChildFields();
    });

    [...this.elements.open_btn].map(btn => {
      btn.addEventListener('click', () => {
        this.toggle();
      });
    });

    [...this.elements.close_btn].map(btn => {
      btn.addEventListener('click', () => {
        this.hide();
      });
    });

    // Close on escape and click on anywhere besides the .guests-cell
    document.querySelector('.guests-cell').addEventListener('click', event => {
      event.stopPropagation();
    });

    document.body.addEventListener('click', () => {
      this.hide();
    });

    document.addEventListener('keyup', event => {
      if (event.keyCode === 27) {
        this.hide();
      }
    });

    // Validation of child input fields
    document.documentElement.addEventListener('input', event => {
      const clickedEl = event.target;
      if (clickedEl.classList.contains('js-dgi-child-item')) {
        this.validateChildAge(clickedEl);
      }
    });

    // Chrome type="number" bug when getting value of input containing letter "e"
    document.documentElement.addEventListener('keypress', event => {
      const clickedEl = event.target;
      if (clickedEl.classList.contains('js-dgi-child-item')) {
        if (event.keyCode === 69 || event.keyCode === 101) {
          event.preventDefault();
        } else {
          this.validateChildAge(clickedEl);
        }
      }
    });
  }

  validateChildAge(field) {
    let age = field.value.replace(/[^0-9]/gi, '');
    while (age < 0 || age > 17) {
      age = age.slice(0, -1);
    }
    age = age !== '' ? parseInt(age, 10) : '';
    field.value = age;
    this.checkChildFields();
  }

  getPreloadedValues() {
    const children_defined = this.elements.children.querySelectorAll(
      '.guests-cell-field',
    );
    for (let i = 0; i < children_defined.length; ++i) {
      this.childItems[i] = children_defined[i];
    }
    this.toggleChildrenContainer();
  }

  addRemoveChildItems(numOfChildren) {
    const currentLength = Object.keys(this.childItems).length;

    if (numOfChildren === currentLength) return;

    if (numOfChildren > currentLength) {
      for (let i = currentLength; i < numOfChildren; i++) {
        this.childItems[i] = this.getChildItem(1 + i);
        this.elements.children.appendChild(this.childItems[i]);
      }
    } else {
      for (let i = numOfChildren; i < currentLength; i++) {
        // Remove from DOM
        removeElement(this.childItems[i]);
        // Delete object property
        delete this.childItems[i];
      }
    }

    this.toggleChildrenContainer();
  }

  populateHiddenFields() {
    let values = [];
    let children = this.elements.children.querySelectorAll(
      '.js-dgi-child-item',
    );
    let children_list = Array.prototype.slice.call(children);

    children_list.map(item => {
      if (/^\d+$/.test(item.value)) {
        // check if number
        values.push(parseInt(item.value, 10)); // add to list of values
      }
    });

    this.elements.input_children.value = values.join('-'); // separate values with '-'
    this.searchModel.setChildrenAge(values);
    //searchbar.callUpdateUrlSimple(this.elements.input_children, 'children');
  }

  toggleChildrenContainer() {
    if (this.childItems[0]) {
      this.elements.children.classList.add('has-items');
    } else {
      this.elements.children.classList.remove('has-items');
    }
  }

  getChildItem(number) {
    let div = document.createElement('div');
    div.classList.add('guests-cell-field');
    div.innerHTML = `<label for="id_guests_child_${number}">${
      this.translations.label
    } ${number}</label><div class="pos-r"><input type="number" id="id_guests_child_${number}" class="has-plhl js-dgi-child-item" min="0" max="17" placeholder="${
      this.translations.placeholder
    }"><label class="plhl" for="id_guests_child_${number}" data-text="${
      this.translations.placeholder
    }"></label></div>`;
    return div;
  }

  previewValueUpdate() {
    let value = 0;
    let select_list = Array.prototype.slice.call(this.elements.select);

    select_list.map(item => {
      value += parseInt(item.value, 10);
    });
    this.elements.preview_value.innerHTML = value;
  }

  toggle() {
    if (this.isOpened === false) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    if (this.isOpened === false) {
      document.documentElement.classList.add('search-form-dropdown-open');
      this.isOpened = true;
    }
  }

  hide() {
    if (this.isOpened === true && this.validChildren === true) {
      this.populateHiddenFields();
      document.documentElement.classList.remove('search-form-dropdown-open');
      this.isOpened = false;
      if (this.callback !== false) this.callback();
    }
  }

  checkChildFields() {
    const confirmButtons = this.elements.close_btn;
    const childElements = [...this.elements.children.querySelectorAll('.js-dgi-child-item')];
    const childElementsWithoutValue = childElements.filter(element => element.value === '');
  
    const childElementsWithError = [...this.elements.children.querySelectorAll('.guests-cell-field.field-with-error')];
    childElementsWithError.forEach(element => element.classList.remove('field-with-error'));

    if (childElementsWithoutValue.length !== 0) {
      this.validChildren = false;
      [...confirmButtons].forEach(button => button.disabled = true);
      childElementsWithoutValue.forEach(element => element.parentNode.parentNode.classList.add('field-with-error'));
    } else {
      this.validChildren = true;
      [...confirmButtons].forEach(button => button.disabled = false);
    }
  }
}

export default DropdownGuests;



// WEBPACK FOOTER //
// ./src/js/dropdown-guests.js